import { render, staticRenderFns } from "./kargoGenelYazdir.vue?vue&type=template&id=e9a7acb4"
import script from "./kargoGenelYazdir.vue?vue&type=script&lang=js"
export * from "./kargoGenelYazdir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports